import { useEffect } from "react";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import PresidentesHeader from "../components/PresidentesHeader";
import PresidentesTimeline from "../components/PresidentesTimeline";

const PRESIDENTES = [
    { numero: 1, nombre: "Alberto Pesce", periodo: "1922-1924" },
    { numero: 2, nombre: "Rodolfo Di Corcia", periodo: "1924-1929" },
    { numero: 3, nombre: "Hebert Cagnoli", periodo: "1929-1931" },
    { numero: 4, nombre: "Juan Mezzetta", periodo: "1931-1933" },
    { numero: 5, nombre: "Pedro Ruggiero", periodo: "1933-1939" },
    { numero: 6, nombre: "Daniel Fernández Crespo", periodo: "1939-1942" },
    { numero: 7, nombre: "Pedro Ruggiero", periodo: "1942-1944" },
    { numero: 8, nombre: "José D’Aiuto", periodo: "1944-1946" },
    { numero: 9, nombre: "Pedro Ruggiero", periodo: "1946-1947" },
    { numero: 10, nombre: "Roberto Infante", periodo: "1947-1968" },
    { numero: 11, nombre: "Gualberto Rodríguez", periodo: "1968-1972" },
    { numero: 12, nombre: "Juan Lanzillioti", periodo: "1972-1973" },
    { numero: 13, nombre: "Arístides Astengo", periodo: "1973-1975" },
    { numero: 14, nombre: "Roberto Infante", periodo: "1975-1982" },
    { numero: 15, nombre: "Roberto Montenegro", periodo: "1982-1984" },
    { numero: 16, nombre: "Raúl Doldán", comentario: "(Presidente Ad Hoc)", periodo: "1984" },
    { numero: 17, nombre: "William Rivera", periodo: "1984-1985" },
    { numero: 18, nombre: "Gualberto Rodríguez", periodo: "1985-1986" },
    { numero: 19, nombre: "Enrique Badano", periodo: "1986-1988" },
    { numero: 20, nombre: "Juan Viña", periodo: "1988-1989" },
    { numero: 21, nombre: "Andrés Pavón", periodo: "1989-1990" },
    { numero: 22, nombre: "Juan P. Bonino", periodo: "1990-1992" },
    { numero: 23, nombre: "Carlos Lorenzo", periodo: "1992-1993" },
    { numero: 24, nombre: "Juan P. Bonino", periodo: "1993-2001" },
    { numero: 25, nombre: "Pedro Villa", periodo: "2001-2002" },
    { numero: 26, nombre: "José L. Montenegro", periodo: "2002-2003" },
    { numero: 27, nombre: "Cristina Rodríguez", periodo: "2003-2006" },
    { numero: 28, nombre: "Daniel Ghislieri", periodo: "2006-2008" },
    { numero: 29, nombre: "Hugo Rodríguez", periodo: "2008-2010" },
    { numero: 30, nombre: "Mario Viola", periodo: "2010-2012" },
    { numero: 31, nombre: "Flavio Perchman", periodo: "2012-2014" },
    { numero: 32, nombre: "Alejandro Mazzeo", periodo: "2014-2022" },
    { numero: 33, nombre: "Daniel Olivera", comentario: "(vicepresidente en ejercicio de la presidencia)", periodo: "2022" },
    { numero: 34, nombre: "Gerardo Rabajda", periodo: "2022-Presente" },
];

function Presidentes() {
    const presidentesOrdenInverso = [...PRESIDENTES].reverse();

    useEffect(() => {
        document.title = "Presidentes";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />

            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <PresidentesHeader />
                <PresidentesTimeline presidentes={presidentesOrdenInverso} />
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Presidentes;